import PropTypes from "prop-types"
import classNames from "classnames"
import errorIconRaw from "images/icons/icon-error-small-red.svg?raw"
import get from "lodash/get"
import parse from "html-react-parser"
import { stripMarkup } from "shared/lib/strip_markup"

import styles from "./error_message.module.scss"

const ERROR_TRANSLATIONS = {
  "Default value can't be blank when the field is required and hidden": "Field cannot be blank",
}

export default function ErrorMessageForField({ field, errors, variant = "on-dark" }) {
  const untranslatedMessage = get(errors, field)
  const errorMessage = ERROR_TRANSLATIONS[untranslatedMessage] || untranslatedMessage

  if (!errorMessage || errorMessage.length === 0) {
    return null
  }

  const messages = Array.isArray(errorMessage) ? errorMessage : [errorMessage]

  return (
    <>
      {messages.map((msg, index) => (
        <span
          key={index}
          className={classNames(styles["error-message"], {
            [styles["error-message-on-light"]]: variant === "on-light",
          })}
        >
          <span className={styles["error-icon"]}>{parse(errorIconRaw)}</span>
          <span>{parse(stripMarkup(msg))}</span>
        </span>
      ))}
    </>
  )
}

ErrorMessageForField.propTypes = {
  field: PropTypes.string.isRequired,
  errors: PropTypes.object,
  variant: PropTypes.oneOf(["on-dark", "on-light"]),
}
